import { SVGAttributes } from "react";

export const BrokenAssetIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" }
) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0a1 1 0 00-1 1v5.4a1 1 0 00.543.89l1.166.6a1 1 0 001.144-.162L4.5 6.174l1.647 1.554a1 1 0 001.372 0l1.648-1.554 1.647 1.554a1 1 0 001.372 0l1.508-1.422.498.683A1 1 0 0016 6.4V1a1 1 0 00-1-1H1zm13 2v1.814a1.006 1.006 0 00-.853.258L11.5 5.626 9.853 4.072a1 1 0 00-1.372 0L6.833 5.626 5.186 4.072a1 1 0 00-1.372 0L2 5.782V2h12zm.623 6.386a1 1 0 00-1.44-.145L11.5 9.683 9.817 8.24a1 1 0 00-1.301 0L6.833 9.683 5.151 8.24a1 1 0 00-1.302 0L1.99 9.836l-.595-.255A1 1 0 000 10.5V15a1 1 0 001 1h14a1 1 0 001-1v-4.5a1 1 0 00-.21-.614l-1.167-1.5zM2 14v-2.014a1 1 0 00.817-.227L4.5 10.317l1.683 1.442a1 1 0 001.301 0l1.683-1.442 1.682 1.442a1 1 0 001.302 0l1.537-1.317.312.401V14H2z"
        fill="currentColor"
      />
    </svg>
  );
};
BrokenAssetIcon.displayName = "BrokenAssetIcon";
